import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '@/components/ui/Button';
import { getConsent, setConsent } from '@/hooks/useTracking';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === null);
  }, []);

  if (!visible) return null;

  const accept = (analytics: boolean, marketing: boolean) => {
    setConsent({ analytics, marketing });
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-40 bg-white shadow-lg rounded-2xl p-6 border border-neutral-100"
          role="dialog"
          aria-label="Cookie consent"
        >
          <p className="text-sm text-ink-700 mb-4">{t('cookies.text')}</p>
          <div className="flex flex-col sm:flex-row gap-2">
            <Button variant="primary" size="sm" fullWidth onClick={() => accept(true, true)}>
              {t('cookies.acceptAll')}
            </Button>
            <Button variant="secondary" size="sm" fullWidth onClick={() => accept(false, false)}>
              {t('cookies.onlyNecessary')}
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
